import { getContrastingColor } from "./hooks/useKeyColors"
import { type ChartImageState } from "./types"

// Background gradient options
export const backgroundPresets: Record<
  string,
  {
    background: {
      className?: string
      style?: Record<string, string>
    }
    text: {
      className?: string
      style?: Record<string, string>
    }
  }
> = {
  default: {
    background: {
      className: "bg-gradient-to-br from-bg-default to-bg-default",
    },
    text: { className: "text-fg-secondary" },
  },
  chart1: {
    background: {
      className:
        "bg-gradient-to-br from-chart-1 to-[color-mix(in_srgb,_hsl(var(--chart-1)),_hsl(var(--bg-default))_50%)]",
    },
    text: { className: "text-fg-default dark:text-bg-default" },
  },
  chart2: {
    background: {
      className:
        "bg-gradient-to-br from-chart-2 to-[color-mix(in_srgb,_hsl(var(--chart-2)),_hsl(var(--bg-default))_50%)]",
    },
    text: { className: "text-bg-default dark:text-fg-default" },
  },
  chart3: {
    background: {
      className:
        "bg-gradient-to-br from-chart-3 to-[color-mix(in_srgb,_hsl(var(--chart-3)),_hsl(var(--bg-default))_50%)]",
    },
    text: { className: "text-fg-default dark:text-fg-default" },
  },
  chart4: {
    background: {
      className:
        "bg-gradient-to-br from-chart-4 to-[color-mix(in_srgb,_hsl(var(--chart-4)),_hsl(var(--bg-default))_50%)]",
    },
    text: { className: "text-fg-default dark:text-bg-default" },
  },
  chart5: {
    background: {
      className:
        "bg-gradient-to-br from-chart-5 to-[color-mix(in_srgb,_hsl(var(--chart-5)),_hsl(var(--bg-default))_50%)]",
    },
    text: { className: "text-fg-default dark:text-bg-default" },
  },
  // radialGradient: {
  //   background: {
  //     style: {
  //       background:
  //         "radial-gradient(at 12% 19%, #106ee8 0px, transparent 50%), radial-gradient(at 44% 42%, #0fc1a1 0px, transparent 50%), radial-gradient(at 15% 53%, #ff6347 0px, transparent 50%), radial-gradient(at 78% 47%, #4682b4 0px, transparent 50%), #106ee8",
  //     },
  //   },
  //   text: { className: "text-white" },
  // },
  // radialGradient2: {
  //   background: {
  //     style: {
  //       background:
  //         "radial-gradient(at 93% 65%, #4682b4 0px, transparent 50%), radial-gradient(at 73% 40%, #e6e9af 0px, transparent 50%), radial-gradient(at 24% 74%, #cbffce 0px, transparent 50%), radial-gradient(at 1% 99%, #90e0ab 0px, transparent 50%), #4682b4",
  //     },
  //   },
  //   text: { className: "text-black" },
  // },
  // radialGradient3: {
  //   background: {
  //     style: {
  //       background:
  //         "radial-gradient(at 39% 89%, #8B5dff 0px, transparent 50%), radial-gradient(at 86% 81%, #cbffce 0px, transparent 50%), radial-gradient(at 23% 67%, #e6e9af 0px, transparent 50%), radial-gradient(at 5% 88%, #432e54 0px, transparent 50%), #8B5dff",
  //     },
  //   },
  //   text: { className: "text-white" },
  // },
} as const

export type BackgroundPreset = keyof typeof backgroundPresets

const makeCustomColorBackground = (color: string) => {
  return {
    className: `bg-gradient-to-br from-[var(--background-color)] to-[color-mix(in_srgb,_var(--background-color),_hsl(var(--bg-default))_35%)]`,
    style: {
      "--background-color": color,
    },
  }
}

const makeCustomColorTextStyles = (color: string) => {
  return {
    style: {
      color: getContrastingColor(color),
    },
  }
}

export const getBackgroundStyles = (
  backgroundState: ChartImageState["background"]
): {
  background: {
    className?: string
    style?: Record<string, string>
  }
  text: {
    className?: string
    style?: Record<string, string>
  }
} => {
  let background = {}
  let text = {}

  if (backgroundState.type === "custom") {
    background = makeCustomColorBackground(backgroundState.customColor ?? "")
    text = makeCustomColorTextStyles(backgroundState.customColor ?? "")
  } else if (backgroundState.type === "preset") {
    background =
      backgroundPresets[backgroundState.presetKey ?? "default"].background
    text = backgroundPresets[backgroundState.presetKey ?? "default"].text
  }

  return { background, text }
}
